import { THEME_NAMES } from '@polyai/ui/styles/config/theme.constants';
import { getAppTheme } from '@polyai/ui/styles/theme';

export const defaultTheme = getAppTheme(THEME_NAMES.DEFAULT);
